import { configureStore } from '@reduxjs/toolkit';
import folderSlice from 'redux/folder/folderSlice';
import dasbhoardSlice from 'redux/dashboard/dasbhoardSlice';
import authSlice from './auth/authSlice';
import sharedSlice from './sharedSlice';
import messageSlice from './common/messageSlice';
import dataSourceSlice from './datasource/dataSourceSlice';
import timeSlice from './time/timeSlice';
import panelsSlice from './panels/panelsSlice';
import userEventSlice from './userLog/userLogSlice';

// eslint-disable-next-line import/prefer-default-export
export const store = configureStore({
    reducer: {
        dashboard: dasbhoardSlice,
        browse: folderSlice,
        shared: sharedSlice,
        auth: authSlice,
        toast: messageSlice,
        datasource: dataSourceSlice,
        time: timeSlice,
        panelsReducer: panelsSlice,
        userLogEvent: userEventSlice,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ serializableCheck: false }),
});
